/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import type {
  GetStatsByDateReportQueryParams,
  GetStatsByDateReport200,
  GetStatsByDateReport400,
  GetStatsByDateReportQueryResponse,
} from '../entities/GetStatsByDateReport'
import type { ToZod } from '@kubb/plugin-zod/utils'
import { errorStructSchema } from './errorStructSchema'
import { z } from 'zod'

export const getStatsByDateReportQueryParamsSchema = z
  .object({
    drivee_city_id: z.number().int().describe('ID города в Drivee').optional(),
    from: z.string().describe('Начальная дата').optional(),
    to: z.string().describe('Конечная дата').optional(),
  })
  .optional() as unknown as ToZod<GetStatsByDateReportQueryParams>

/**
 * @description Binary file
 */
export const getStatsByDateReport200Schema = z.instanceof(File) as unknown as ToZod<GetStatsByDateReport200>

/**
 * @description Bad Request
 */
export const getStatsByDateReport400Schema = z.lazy(() => errorStructSchema) as unknown as ToZod<GetStatsByDateReport400>

export const getStatsByDateReportQueryResponseSchema = z.lazy(() => getStatsByDateReport200Schema) as unknown as ToZod<GetStatsByDateReportQueryResponse>